import { useEffect, useState } from 'react';

/**
 * Estado local da coluna Em aberto, hidratado pelo perfil do usuário.
 */
export function useOpenColumnCollapsedPreference(initialCollapsed = false) {
  const [collapsed, setCollapsed] = useState(Boolean(initialCollapsed));

  useEffect(() => {
    setCollapsed(Boolean(initialCollapsed));
  }, [initialCollapsed]);

  return [collapsed, setCollapsed];
}
